import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getAllPayments } from '../../../store/payment'
import { getUsers } from '../../../store/session';
import VenmoCard from "../VenmoCard/VenmoCard";
import BalanceCard from "../BalanceCard/BalanceCard";
import TransactionHistory from "../TransactionHistory/TransactionHistory";
import userService from "../../../utils/userService";
import balanceService from "../../../utils/balanceService";
import './Home.css'

const Home = () => {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const [userBalance, setUserBalance] = useState(0);
  
  const allPayments = Object.values(useSelector(state => state.paymentState));
  const sessionUser = useSelector(state => state.session.user);
  const allUsers = Object.values(useSelector(state => state.session));
  
  // Get updated user data with current balances
  const [currentUserData, setCurrentUserData] = useState(null);
  const [allTransactions, setAllTransactions] = useState([]);

  useEffect(() => {
    (async() => {
      await dispatch(getAllPayments());
      await dispatch(getUsers());
      
      // Get updated user data with current balance
      const updatedUsers = balanceService.getAllUsers();
      const userData = updatedUsers.find(user => user.id === (sessionUser?.id || 1));
      if (userData) {
        setCurrentUserData(userData);
        setUserBalance(userData.balance);
      }
      
      // Get all transactions including new ones
      const transactions = balanceService.getAllTransactions();
      setAllTransactions(transactions);
      
      return setLoaded(true);
    })();
  }, [dispatch, sessionUser]);

  const handleLike = (transactionId, userId) => {
    const transaction = allPayments.find(p => p.id === transactionId);
    const hasLiked = transaction?.likes.likes.some(like => like.user_id === userId);
    
    if (hasLiked) {
      userService.removeLike(transactionId, userId);
    } else {
      userService.addLike(transactionId, userId);
    }
    
    // Refresh payments to show updated likes
    dispatch(getAllPayments());
  };

  const handleComment = (transactionId) => {
    // For now, just console log - could implement a modal or navigate to detail view
    console.log('Open comments for transaction:', transactionId);
  };

  const history = useHistory();

  const handleSendMoney = () => {
    history.push('/pay');
  };

  const handleRequestMoney = () => {
    history.push('/pay');
  };

  if (!loaded) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <p>Loading your feed...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <BalanceCard 
        user={currentUserData || sessionUser}
        onSendMoney={handleSendMoney}
        onRequestMoney={handleRequestMoney}
      />
      
      <div className="feed-header">
        <h2>Transaction History</h2>
        <p>Stay up to date with your friends' payments</p>
      </div>
      
      <div className="payments-feed">
        <TransactionHistory 
          transactions={allTransactions.length > 0 ? allTransactions : allPayments} 
          users={balanceService.getAllUsers()}
          currentUser={currentUserData || sessionUser}
        />
      </div>
    </div>
  );
};

export default Home;
